import type { QueryClient } from "@tanstack/react-query";
import type { SectionDefinition } from "./types";

export function defineSection<P>(def: SectionDefinition<P>): SectionDefinition<P> {
  return def;
}

/**
 * Builds a TanStack Router `loader` that prefetches every query declared
 * by any section in `sections`, in parallel.
 */
export function collectSectionQueries(
  sections: ReadonlyArray<SectionDefinition<any>>,
) {
  return async ({ context }: { context: { queryClient: QueryClient } }) => {
    const all = sections.flatMap((s) => s.queries ?? []);
    if (all.length === 0) return;
    await Promise.all(all.map((q) => context.queryClient.prefetchQuery(q)));
  };
}
